import React, { useEffect, useState } from "react";
import { FaEnvelope, FaIdCard, FaSpinner, FaUser } from "react-icons/fa6";
import { LiaTimesCircle } from "react-icons/lia";
import {
  capitalizeEachWord,
  addTeacher,
  cleanMatric,
  cleanName,
} from "../../AppManager";

export default function AddTeacher() {
  const [formData, setFormData] = useState({ name: "", matric: "", email: "" });
  const [status, setStatus] = useState({ status: "", type: "", message: "" });
  const [uploading, setUploading] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((oldFormData) => {
      let newFormData = {
        ...oldFormData,
        [name]:
          name === "name"
            ? cleanName(capitalizeEachWord(value))
            : name === "matric"
            ? cleanMatric(value)
            : value,
      };
      return newFormData;
    });
  }

  async function handleSubmit(e) {
    try {
      e.preventDefault();
      setUploading(true);
      const res = await addTeacher(formData);
      if (res === "Registered") {
        setTimeout(() => {
          setStatus({
            status: "success",
            type: "success",
            message: "Registration Successful",
          });
          setFormData({
            name: "",
            matric: "",
            email: "",
          });
          setUploading(false);
        }, 1000);
      } else if (res === "Exists") {
        setStatus({
          status: "exists",
          type: "failed",
          message: "Already Registered",
        });
        setUploading(false);
      } else if (res === "Email") {
        setStatus({
          status: "email",
          type: "failed",
          message: "Email Taken",
        });
        setUploading(false);
      } else {
        setStatus({
          status: "error",
          type: "failed",
          message: "Registration Failed",
        });
        setUploading(false);
      }
    } catch (error) {
      setStatus({
        status: "error",
        type: "failed",
        message: "Registration Failed",
      });
      setUploading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  document.title = "Teacher Registration";

  return (
    <section className="contactform registration spec">
      <div className="formwrapper">
        <div className={`wrapper`}>
          <div className="form-box login">
            <h2>Teacher Registration</h2>
            <form onSubmit={handleSubmit}>
              {status.message !== "" && (
                <p className="status-wrapper" id="status-wrapper">
                  <span className={`status-message ${status.type}`}>
                    {status.message}
                  </span>
                  <LiaTimesCircle
                    className="status-close"
                    onClick={() => {
                      setStatus({ status: "", type: "", message: "" });
                    }}
                  />
                </p>
              )}
              <div className="input-box">
                <span className="icon">
                  <FaUser />
                </span>
                <input
                  readOnly={uploading}
                  placeholder=" "
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                  minLength={7}
                  maxLength={25}
                  pattern="[A-Za-z\- ]+"
                />
                <label>Name</label>
              </div>
              <div className="input-box">
                <span className="icon">
                  <FaIdCard />
                </span>
                <input
                  readOnly={uploading}
                  placeholder=" "
                  type="text"
                  name="matric"
                  style={{ textTransform: "uppercase" }}
                  value={formData.matric}
                  onChange={handleChange}
                  autoComplete="off"
                  pattern="^(RUN|RUn|Run|rUN|ruN|run|rUn|RUn)/[A-Za-z]{3}(-[A-Za-z])?/\d{2}/\d{4,5}$|(RUN|RUn|Run|rUN|ruN|run|rUn|RUn)/(FD|fd|Fd|fD)/\d{2}/\d{4,5}$|\d{12}[A-Za-z]{2}|\d{8}[A-Za-z]{2}|[A-Za-z]{3}\d{2}/\d{2}/\d{4,5}$"
                  title="RUN/xxx/yy/yyyy | JAMB Number"
                  maxLength={18}
                  required
                />
                <label>Matric Number</label>
              </div>
              <div className="input-box">
                <span className="icon">
                  <FaEnvelope />
                </span>
                <input
                  readOnly={uploading}
                  placeholder=" "
                  type="email"
                  name="email"
                  value={formData.email}
                  minLength={13}
                  maxLength={50}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
                <label>E-Mail</label>
              </div>
              <button type="submit" disabled={uploading} className="btn">
                {uploading ? <FaSpinner className="spinner" /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
